// import {getEnv} from '../shared/Services/env'
import {getLocal} from './storage'

export const isBeta = async () => {
  console.error('Figure out where the \'betaAccess\' property should be stored (server db or locaStorege). Make beta access work.');
  return false;
  return await getLocal('betaAccess') === 'true';
}
// const realBeta = remote.getGlobal('env')
const appUrl = async (ignoreBeta = false)=>{
  const ib = await isBeta()
  console.log('APPURL WITH ISBETA', ib)
  return `${process.env['REACT_APP_APP_URL']}${(ib ==='true') && !ignoreBeta?'/beta':''}`
}

function handleResponse(response) {
  return response.text().then(text => {
    // console.log('parsing res', text)
    const data = text && JSON.parse(text)
    if (!response.ok) {
      let errText = (data && data.message) || response.statusText
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        const error = new Error(errText)
        // console.log('perform auto logout')
        return Promise.reject(error)
      }
      const error = new Error(errText)
      return Promise.reject(error)
    }

    return data
  })
}

async function authHeader() {
  // return authorization header with jwt token
  let token = await getLocal('token')
  if (token) {
    return { 'Authorization': 'Bearer ' + token }
  } else {
    return {}
  }
}

export async function login(username, password) {
  // console.log(`logging ${username} in with ${password}`)
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({username, password}),
  }
  const appurl = await appUrl() 
  let url = `${process.env['REACT_APP_PROTOCOL']}:${appurl}/users/authenticate`
  // console.log('looking at process', process)
  // console.log('fetch user with url', url)
  // console.log('in login service with:', requestOptions, url)
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(async user => {
      // console.log('after handleResponse then, about to attempt setLocal', user)
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      return user
    })
}

export async function logout(){
  const appurl = await appUrl()
  return fetch(`${process.env.REACT_APP_PROTOCOL}:${appurl}/users/logout`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  })
}

export async function checkToken() {
  // const headers = await authHeader()
  // console.log('fetch myself with url', `${prot}:${appUrl}/users/current`)
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' }
  }
  const appurl = await appUrl() 
  console.log('app url?????', appurl)
  return fetch(`${process.env['REACT_APP_PROTOCOL']}:${appurl}/users/current`, requestOptions)
    .then(handleResponse)
    .catch(function(e){
      throw new Error(e.message)

      // throw e.toMS(Error.API_CALL, 'users/update/:id')
    })
}
